import { render, staticRenderFns } from "./photo-swipe.vue?vue&type=template&id=1e89e71e&"
import script from "./photo-swipe.vue?vue&type=script&lang=js&"
export * from "./photo-swipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports